import { defineComponent as _defineComponent } from 'vue'
import { mergeProps as _mergeProps, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { onErrorCaptured, ref } from "vue";
import CohortCalendar from "@/components/CohortCalendar.vue";

interface CohortCalendarProps {
  cohortId: string;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'CohortCalendarWrapper',
  props: {
    cohortId: {}
  },
  setup(__props: any) {

const props = __props;



const showError = ref(false);

onErrorCaptured(() => {
  showError.value = true;
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(CohortCalendar, _mergeProps(props, {
    class: showError.value && 'calendar-errors'
  }), null, 16, ["class"]))
}
}

})